import { COSIGN_TOKEN_KEY, COSIGN_X_PLATFORM_TOKEN } from '@constants'
import Cookies from 'js-cookie'
import { getClient } from '../clients'

interface ClearTokenProps {
  campaignCodeFromUrl: string
}

export const clearToken = ({ campaignCodeFromUrl }: ClearTokenProps) => {
  Cookies.remove(`${campaignCodeFromUrl}_${COSIGN_TOKEN_KEY}`)
  Cookies.remove(`${campaignCodeFromUrl}_${COSIGN_X_PLATFORM_TOKEN}`)
  Cookies.remove('x-platform-token')
  sessionStorage.removeItem('admin')
  getClient('fortune').defaults.headers['access-token'] = ''
  getClient('butler').defaults.headers.Authorization = ''
  getClient('fastpassAdmin').defaults.headers['admin-access-token'] = ''
}
